import { render } from "./CreateUserForm.vue?vue&type=template&id=1dddeefa&ts=true"
import script from "./CreateUserForm.vue?vue&type=script&lang=ts"
export * from "./CreateUserForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__